<template>
    <div class="group-rules">
        <label for="">Voeg bijlages aan jouw groep toe. Klik op uploaden en druk op het plusje om meerdere toe te voegen.</label>
        <div class="row">
      
            <div class="col-xs-12">
                <template v-if="attachments.length > 0">
                        
                    <div v-for="(attachment, index) in attachments" :key="attachment.id" class="col-sm-6">
                        <div class="flex-wrapper flex-align-center group-member m-b">
                            
                            <i class="fa fa-file-pdf m-r"></i>
                            <div style="flex-grow:1;">
                                <a href="/">
                                    {{ attachment.filename.substring(0, 30) }}
                                </a><br>
                                <span class="group-active-since">toegevoegd {{ attachment.created_at }}</span>
                            </div>
                            
                            <a type="button" class="btn btn-xs btn-default m-r" :href="attachment.url"><i class="fa fa-download"></i> Download</a>
                            <button type="button" class="btn btn-xs btn-danger" @click="deleteAttachment(attachment)"><i class="fa fa-trash"></i> Verwijder</button>

                        </div>
					</div>

                </template>
                <template v-else>
                    <p>Deze groep heeft geen bijlages. Voeg er een toe door op het plus icoon te klikken.</p>
                </template>
            </div>
           
            <div class="col-md-12">
              <div class="tw-flex tw-items-center">
                <input type="file" id="uploading" ref="uploading" style="display: none" @change="addAttachment($event);" />
                <i v-if="uploading" class="fa fa-spinner fa-spin tw--mt-3"></i>
                <button class="btn default m-b clearfix btn-xs m-l" type="button" @click="$refs.uploading.click()"><i class="fa fa-plus-circle"></i> een bijlage toevoegen</button>
              </div>
            </div>
            <div class="col-xs-12">
                <hr>
            </div>
        </div>
    </div>
</template>

<script>
export default {
	props: [ 'group' ],
	data() {
		return {
			attachments: [],
			uploading: false,
		};
	},
	mounted() {
		this.groupInfo = JSON.parse(this.group);
		this.attachments = this.groupInfo.channel.uploads;
	},
	methods: {
		addAttachment(event) {
			let file = event.target.files[0];
			let that = this;

			var formData = new FormData();
			var fileInput = document.querySelector('#uploading');

			formData.append('file', fileInput.files[0]);
			formData.append('model', 'channel');
			formData.append('modelId', this.groupInfo.channel.id);

			this.uploading = true;
            
			axios.post('/api/v3/uploads', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then(function(response){
				that.attachments.push(response.data.data);
				that.uploading = false;
			}).catch(() => {
				this.uploading = false;
				alert('Upload mislukt. Controleer de grootte van je bestand of neem contact op met de klantenservice.');
			});
            
		},
		deleteAttachment(attachment) {
			let that = this;
			axios.delete(`/api/v3/uploads/${attachment.id}`).then(function(){
				that.attachments.splice(that.attachments.indexOf(attachment), 1);
			});
		},
	}
};
</script>